import React from 'react'
import colors from '../../../utils/colors';
import { useViewport, viewportBreakpoint } from '../../../utils';

const COLORS = [colors.green, '#52BAE2', '#FF5448', '#7171EF', '#FFC020', '#753A00'];

const ColorSelect = () => {
  const [selected, setSelected] = React.useState(COLORS[0])

  const { width } = useViewport()
  const isMobile = width < viewportBreakpoint.tablet

  const style = {
    width: isMobile ? '14px' : '20px',
    height: isMobile ? '14px' : '20px',
  }

  return (
    <div className="flex">
      {
        COLORS.map((c, index) => (
          <div
            key={index}
            className={`bg-white rounded rounded-full border mr-3 lg:mr-5 cursor-pointer`}
            style={{borderColor: c === selected ? c : '#fff'}}
            onClick={() => setSelected(c)}
          >
            <div
              key={index}
              style={{
                backgroundColor: c,
                ...style
              }}
              className="rounded rounded-full m-1"
            />
          </div>
        ))
      }
    </div>
  )
}

export { ColorSelect }